module.exports = __webpack_public_path__ + "img/17.a52addc2.jpg";